import axios from "axios";
import { INVOICES_URL } from "../../../Accounting/_redux/invoices/invoicesCrud";

export const INVESTIGATIONS_URL = `${process.env.REACT_APP_API_URL}/investigations`;

// READ
export function FindInvestigations(queryParams) {
  return axios.get(INVESTIGATIONS_URL, {
    params: {
      pageSize: queryParams.pageSize,
      pageNumber: queryParams.pageNumber,
    },
  });
}

export function GetInvestigationById(investigationId) {
  return axios.get(`${INVESTIGATIONS_URL}/${investigationId}`);
}

// Create
export function CreateInvestigation(investigation) {
  return axios.post(INVESTIGATIONS_URL, investigation);
}

// Update
export function UpdateInvestigation({ id, description }) {
  return axios.put(INVESTIGATIONS_URL, {
    id: id,
    description: description,
  });
}

// Delete
export function DeleteInvestigation(investigationId) {
  return axios.delete(`${INVESTIGATIONS_URL}/${investigationId}`);
}
